import { Component, ReactNode } from 'react'

interface Props {
  children?: ReactNode
}

interface State {
  hasError: boolean
}

class ComponentErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  }

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true }
  }

  public render() {
    if (this.state.hasError) {
      return null
    }

    return this.props.children
  }
}

export default ComponentErrorBoundary
